import React from 'react';
import { useTranslation } from 'react-i18next';

const Header: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="text-start" style={{ marginBottom: '28px' }}>
      <p
        className="voice-eyebrow"
        style={{
          fontFamily: "'Schibsted Grotesk', sans-serif",
          fontSize: '11px',
          textTransform: 'uppercase',
          letterSpacing: '0.26em',
          fontWeight: 500,
          color: 'var(--dim, #767972)',
          marginBottom: '8px',
        }}
      >
        AUTH CONSOLE
      </p>
      <h1
        className="font-serif m-0"
        style={{
          fontFamily: "'Source Serif 4', Georgia, serif",
          fontSize: '2rem',
          fontWeight: 500,
          lineHeight: 1,
          color: 'var(--txt, #0A0B0D)',
        }}
      >
        CoHostZone<em className="not-italic" style={{ color: 'var(--acc, #0A0B0D)' }}>.</em>
      </h1>
      <p className="mb-0" style={{ fontSize: '13.5px', color: 'var(--dim, #767972)', marginTop: '10px' }}>
        {t('login.pageTexts.header.subTitle') || 'Sign in to access the property management console.'}
      </p>
    </div>
  );
};

export default Header;
